export const instanceTypes = {
	aws: [
		{ type: 't2.micro', cpu: '1', memory: '1', price: '0.0162' },
		{ type: 't2.nano', cpu: '1', memory: '0.5', price: '0.0081' },
		{ type: 't2.small', cpu: '1', memory: '2', price: '0.032' },
		{ type: 't3a.large', cpu: '2', memory: '8', price: '0.1028' },
		{ type: 't3.medium', cpu: '2', memory: '4', price: '0.06' },
		{ type: 'm5a.large', cpu: '2', memory: '8', price: '0.178' },
		{ type: 't2.medium', cpu: '2', memory: '4', price: '0.0644' },
		{ type: 't2.large', cpu: '2', memory: '8', price: '0.1208' },
		{ type: 't3.nano', cpu: '2', memory: '0.5', price: '0.0098' },
		{ type: 'm5zn.large', cpu: '2', memory: '8', price: '0.2572' },
		{ type: 't3a.small', cpu: '2', memory: '2', price: '0.0372' },
		{ type: 't3.small', cpu: '2', memory: '2', price: '0.0392' },
		{ type: 'm5ad.large', cpu: '2', memory: '8', price: '0.195' },
		{ type: 'm5.large', cpu: '2', memory: '8', price: '0.188' },
		{ type: 'm5d.large', cpu: '2', memory: '8', price: '0.205' },
		{ type: 'm5n.large', cpu: '2', memory: '8', price: '0.211' },
		{ type: 'm5dn.large', cpu: '2', memory: '8', price: '0.228' },
		{ type: 'm6i.large', cpu: '2', memory: '8', price: '0.188' },
		{ type: 't3a.nano', cpu: '2', memory: '0.5', price: '0.0093' },
		{ type: 'm4.large', cpu: '2', memory: '8', price: '0.192' },
		{ type: 't3a.medium', cpu: '2', memory: '4', price: '0.056' },
		{ type: 't3.micro', cpu: '2', memory: '1', price: '0.0196' },
		{ type: 't3.large', cpu: '2', memory: '8', price: '0.1108' },
		{ type: 't3a.micro', cpu: '2', memory: '1', price: '0.0186' },
		{ type: 't2.xlarge', cpu: '4', memory: '16', price: '0.2266' },
		{ type: 't3a.xlarge', cpu: '4', memory: '16', price: '0.224' },
		{ type: 'm5.xlarge', cpu: '4', memory: '16', price: '0.376' },
		{ type: 'm5a.xlarge', cpu: '4', memory: '16', price: '0.356' },
		{ type: 'm5d.xlarge', cpu: '4', memory: '16', price: '0.41' },
		{ type: 'm5n.xlarge', cpu: '4', memory: '16', price: '0.422' },
		{ type: 'm5dn.xlarge', cpu: '4', memory: '16', price: '0.456' },
		{ type: 'm4.xlarge', cpu: '4', memory: '16', price: '0.384' },
		{ type: 'm5ad.xlarge', cpu: '4', memory: '16', price: '0.39' },
		{ type: 'm5zn.xlarge', cpu: '4', memory: '16', price: '0.5143' },
		{ type: 't3.xlarge', cpu: '4', memory: '16', price: '0.24' },
		{ type: 'm6i.xlarge', cpu: '4', memory: '16', price: '0.376' },
		{ type: 'm5dn.2xlarge', cpu: '8', memory: '32', price: '0.912' },
		{ type: 't3a.2xlarge', cpu: '8', memory: '32', price: '0.448' },
		{ type: 'm4.2xlarge', cpu: '8', memory: '32', price: '0.768' },
		{ type: 'm6i.2xlarge', cpu: '8', memory: '32', price: '0.752' },
		{ type: 'm5d.2xlarge', cpu: '8', memory: '32', price: '0.82' },
		{ type: 't2.2xlarge', cpu: '8', memory: '32', price: '0.4332' },
		{ type: 't3.2xlarge', cpu: '8', memory: '32', price: '0.48' },
		{ type: 'm5ad.2xlarge', cpu: '8', memory: '32', price: '0.78' },
		{ type: 'm5.2xlarge', cpu: '8', memory: '32', price: '0.752' },
		{ type: 'm5n.2xlarge', cpu: '8', memory: '32', price: '0.844' },
		{ type: 'm5a.2xlarge', cpu: '8', memory: '32', price: '0.712' },
		{ type: 'm5zn.2xlarge', cpu: '8', memory: '32', price: '1.0287' },
		{ type: 'm5zn.3xlarge', cpu: '12', memory: '48', price: '1.543' },
		{ type: 'm5dn.4xlarge', cpu: '16', memory: '64', price: '1.824' },
		{ type: 'm5.4xlarge', cpu: '16', memory: '64', price: '1.504' },
		{ type: 'm6i.4xlarge', cpu: '16', memory: '64', price: '1.504' },
		{ type: 'm5a.4xlarge', cpu: '16', memory: '64', price: '1.424' },
		{ type: 'm5ad.4xlarge', cpu: '16', memory: '64', price: '1.56' },
		{ type: 'm5n.4xlarge', cpu: '16', memory: '64', price: '1.688' },
		{ type: 'm5d.4xlarge', cpu: '16', memory: '64', price: '1.64' },
		{ type: 'm4.4xlarge', cpu: '16', memory: '64', price: '1.536' },
		{ type: 'm5zn.6xlarge', cpu: '24', memory: '96', price: '3.086' },
		{ type: 'm5dn.8xlarge', cpu: '32', memory: '128', price: '3.648' },
		{ type: 'm5n.8xlarge', cpu: '32', memory: '128', price: '3.376' },
		{ type: 'm5a.8xlarge', cpu: '32', memory: '128', price: '2.848' },
		{ type: 'm5.8xlarge', cpu: '32', memory: '128', price: '3.008' },
		{ type: 'm5ad.8xlarge', cpu: '32', memory: '128', price: '3.12' },
		{ type: 'm6i.8xlarge', cpu: '32', memory: '128', price: '3.008' },
		{ type: 'm5d.8xlarge', cpu: '32', memory: '128', price: '3.28' },
		{ type: 'm4.10xlarge', cpu: '40', memory: '160', price: '3.84' },
		{ type: 'm5a.12xlarge', cpu: '48', memory: '192', price: '4.272' },
		{ type: 'm5ad.12xlarge', cpu: '48', memory: '192', price: '4.68' },
		{ type: 'm5.12xlarge', cpu: '48', memory: '192', price: '4.512' },
		{ type: 'm5d.12xlarge', cpu: '48', memory: '192', price: '4.92' },
		{ type: 'm5dn.12xlarge', cpu: '48', memory: '192', price: '5.472' },
		{ type: 'm5n.12xlarge', cpu: '48', memory: '192', price: '5.064' },
		{ type: 'm5zn.metal', cpu: '48', memory: '192', price: '6.1721' },
		{ type: 'm5zn.12xlarge', cpu: '48', memory: '192', price: '6.1721' },
		{ type: 'm6i.12xlarge', cpu: '48', memory: '192', price: '4.512' },
		{ type: 'm5dn.16xlarge', cpu: '64', memory: '256', price: '7.296' },
		{ type: 'm5.16xlarge', cpu: '64', memory: '256', price: '6.016' },
		{ type: 'm4.16xlarge', cpu: '64', memory: '256', price: '6.144' },
		{ type: 'm5d.16xlarge', cpu: '64', memory: '256', price: '6.56' },
		{ type: 'm5n.16xlarge', cpu: '64', memory: '256', price: '6.752' },
		{ type: 'm5ad.16xlarge', cpu: '64', memory: '256', price: '6.24' },
		{ type: 'm5a.16xlarge', cpu: '64', memory: '256', price: '5.696' },
		{ type: 'm6i.16xlarge', cpu: '64', memory: '256', price: '6.016' },
		{ type: 'm5.24xlarge', cpu: '96', memory: '384', price: '9.024' },
		{ type: 'm5n.metal', cpu: '96', memory: '384', price: '10.128' },
		{ type: 'm5d.metal', cpu: '96', memory: '384', price: '9.84' },
		{ type: 'm6i.24xlarge', cpu: '96', memory: '384', price: '9.024' },
		{ type: 'm5dn.24xlarge', cpu: '96', memory: '384', price: '10.944' },
		{ type: 'm5d.24xlarge', cpu: '96', memory: '384', price: '9.84' },
		{ type: 'm5ad.24xlarge', cpu: '96', memory: '384', price: '9.36' },
		{ type: 'm5n.24xlarge', cpu: '96', memory: '384', price: '10.128' },
		{ type: 'm5.metal', cpu: '96', memory: '384', price: '9.024' },
		{ type: 'm5dn.metal', cpu: '96', memory: '384', price: '10.944' },
		{ type: 'm5a.24xlarge', cpu: '96', memory: '384', price: '8.544' },
		{ type: 'm6i.32xlarge', cpu: '128', memory: '512', price: '12.032' },
		{ type: 'c5d.large', cpu: '2', memory: '4', price: '0.188' },
		{ type: 'c5ad.large', cpu: '2', memory: '4', price: '0.178' },
		{ type: 'c5a.large', cpu: '2', memory: '4', price: '0.169' },
		{ type: 'c5n.large', cpu: '2', memory: '5.25', price: '0.20' },
		{ type: 'c4.large', cpu: '2', memory: '3.75', price: '0.192' },
		{ type: 'c5.large', cpu: '2', memory: '4', price: '0.177' },
		{ type: 'c4.xlarge', cpu: '4', memory: '7.5', price: '0.383' },
		{ type: 'c5n.xlarge', cpu: '4', memory: '10.5', price: '0.40' },
		{ type: 'c5.xlarge', cpu: '4', memory: '8', price: '0.354' },
		{ type: 'c5ad.xlarge', cpu: '4', memory: '8', price: '0.356' },
		{ type: 'c5d.xlarge', cpu: '4', memory: '8', price: '0.376' },
		{ type: 'c5a.xlarge', cpu: '4', memory: '8', price: '0.338' },
		{ type: 'c5ad.2xlarge', cpu: '8', memory: '16', price: '0.712' },
		{ type: 'c5a.2xlarge', cpu: '8', memory: '16', price: '0.676' },
		{ type: 'c5d.2xlarge', cpu: '8', memory: '16', price: '0.752' },
		{ type: 'c4.2xlarge', cpu: '8', memory: '15', price: '0.766' },
		{ type: 'c5.2xlarge', cpu: '8', memory: '16', price: '0.708' },
		{ type: 'c5n.2xlarge', cpu: '8', memory: '21', price: '0.80' },
		{ type: 'c4.4xlarge', cpu: '16', memory: '30', price: '1.532' },
		{ type: 'c5n.4xlarge', cpu: '16', memory: '42', price: '1.60' },
		{ type: 'c5ad.4xlarge', cpu: '16', memory: '32', price: '1.424' },
		{ type: 'c5a.4xlarge', cpu: '16', memory: '32', price: '1.352' },
		{ type: 'c5d.4xlarge', cpu: '16', memory: '32', price: '1.504' },
		{ type: 'c5.4xlarge', cpu: '16', memory: '32', price: '1.416' },
		{ type: 'c5a.8xlarge', cpu: '32', memory: '64', price: '2.704' },
		{ type: 'c5ad.8xlarge', cpu: '32', memory: '64', price: '2.848' },
		{ type: 'c4.8xlarge', cpu: '36', memory: '60', price: '3.091' },
		{ type: 'c5.9xlarge', cpu: '36', memory: '72', price: '3.186' },
		{ type: 'c5d.9xlarge', cpu: '36', memory: '72', price: '3.384' },
		{ type: 'c5n.9xlarge', cpu: '36', memory: '96', price: '3.60' },
		{ type: 'c5ad.12xlarge', cpu: '48', memory: '96', price: '4.272' },
		{ type: 'c5.12xlarge', cpu: '48', memory: '96', price: '4.248' },
		{ type: 'c5a.12xlarge', cpu: '48', memory: '96', price: '4.056' },
		{ type: 'c5d.12xlarge', cpu: '48', memory: '96', price: '4.512' },
		{ type: 'c5ad.16xlarge', cpu: '64', memory: '128', price: '5.696' },
		{ type: 'c5a.16xlarge', cpu: '64', memory: '128', price: '5.408' },
		{ type: 'c5n.18xlarge', cpu: '72', memory: '192', price: '7.20' },
		{ type: 'c5d.18xlarge', cpu: '72', memory: '144', price: '6.768' },
		{ type: 'c5.18xlarge', cpu: '72', memory: '144', price: '6.372' },
		{ type: 'c5n.metal', cpu: '72', memory: '192', price: '7.20' },
		{ type: 'c5.metal', cpu: '96', memory: '192', price: '8.496' },
		{ type: 'c5d.24xlarge', cpu: '96', memory: '192', price: '9.024' },
		{ type: 'c5.24xlarge', cpu: '96', memory: '192', price: '8.496' },
		{ type: 'c5ad.24xlarge', cpu: '96', memory: '192', price: '8.544' },
		{ type: 'c5d.metal', cpu: '96', memory: '192', price: '9.024' },
		{ type: 'c5a.24xlarge', cpu: '96', memory: '192', price: '8.112' },
		{ type: 'r5b.large', cpu: '2', memory: '16', price: '0.241' },
		{ type: 'r5a.large', cpu: '2', memory: '16', price: '0.205' },
		{ type: 'r5.large', cpu: '2', memory: '16', price: '0.218' },
		{ type: 'z1d.large', cpu: '2', memory: '16', price: '0.278' },
		{ type: 'r5d.large', cpu: '2', memory: '16', price: '0.236' },
		{ type: 'r5ad.large', cpu: '2', memory: '16', price: '0.223' },
		{ type: 'r5dn.large', cpu: '2', memory: '16', price: '0.259' },
		{ type: 'r5n.large', cpu: '2', memory: '16', price: '0.241' },
		{ type: 'r4.large', cpu: '2', memory: '15.25', price: '0.225' },
		{ type: 'r5n.xlarge', cpu: '4', memory: '32', price: '0.482' },
		{ type: 'x1e.xlarge', cpu: '4', memory: '122', price: '1.018' },
		{ type: 'r5b.xlarge', cpu: '4', memory: '32', price: '0.482' },
		{ type: 'r5dn.xlarge', cpu: '4', memory: '32', price: '0.518' },
		{ type: 'r4.xlarge', cpu: '4', memory: '30.5', price: '0.45' },
		{ type: 'r5ad.xlarge', cpu: '4', memory: '32', price: '0.446' },
		{ type: 'r5.xlarge', cpu: '4', memory: '32', price: '0.436' },
		{ type: 'z1d.xlarge', cpu: '4', memory: '32', price: '0.556' },
		{ type: 'r5a.xlarge', cpu: '4', memory: '32', price: '0.41' },
		{ type: 'r5d.xlarge', cpu: '4', memory: '32', price: '0.472' },
		{ type: 'r5dn.2xlarge', cpu: '8', memory: '64', price: '1.036' },
		{ type: 'r5b.2xlarge', cpu: '8', memory: '64', price: '0.964' },
		{ type: 'r5d.2xlarge', cpu: '8', memory: '64', price: '0.944' },
		{ type: 'z1d.2xlarge', cpu: '8', memory: '64', price: '1.112' },
		{ type: 'r5.2xlarge', cpu: '8', memory: '64', price: '0.872' },
		{ type: 'r4.2xlarge', cpu: '8', memory: '61', price: '0.90' },
		{ type: 'r5ad.2xlarge', cpu: '8', memory: '64', price: '0.892' },
		{ type: 'r5n.2xlarge', cpu: '8', memory: '64', price: '0.964' },
		{ type: 'r5a.2xlarge', cpu: '8', memory: '64', price: '0.82' },
		{ type: 'x1e.2xlarge', cpu: '8', memory: '244', price: '2.036' },
		{ type: 'z1d.3xlarge', cpu: '12', memory: '96', price: '1.668' },
		{ type: 'r5dn.4xlarge', cpu: '16', memory: '128', price: '2.072' },
		{ type: 'r5ad.4xlarge', cpu: '16', memory: '128', price: '1.784' },
		{ type: 'r5a.4xlarge', cpu: '16', memory: '128', price: '1.64' },
		{ type: 'r5d.4xlarge', cpu: '16', memory: '128', price: '1.888' },
		{ type: 'x1e.4xlarge', cpu: '16', memory: '488', price: '4.072' },
		{ type: 'r5n.4xlarge', cpu: '16', memory: '128', price: '1.928' },
		{ type: 'r5.4xlarge', cpu: '16', memory: '128', price: '1.744' },
		{ type: 'r4.4xlarge', cpu: '16', memory: '122', price: '1.80' },
		{ type: 'r5b.4xlarge', cpu: '16', memory: '128', price: '1.928' },
		{ type: 'z1d.6xlarge', cpu: '24', memory: '192', price: '3.336' },
		{ type: 'r5n.8xlarge', cpu: '32', memory: '256', price: '3.856' },
		{ type: 'r4.8xlarge', cpu: '32', memory: '244', price: '3.60' },
		{ type: 'x1e.8xlarge', cpu: '32', memory: '976', price: '8.144' },
		{ type: 'r5d.8xlarge', cpu: '32', memory: '256', price: '3.776' },
		{ type: 'r5b.8xlarge', cpu: '32', memory: '256', price: '3.856' },
		{ type: 'r5a.8xlarge', cpu: '32', memory: '256', price: '3.28' },
		{ type: 'r5.8xlarge', cpu: '32', memory: '256', price: '3.488' },
		{ type: 'r5dn.8xlarge', cpu: '32', memory: '256', price: '4.144' },
		{ type: 'r5ad.8xlarge', cpu: '32', memory: '256', price: '3.568' },
		{ type: 'r5ad.12xlarge', cpu: '48', memory: '384', price: '5.352' },
		{ type: 'r5n.12xlarge', cpu: '48', memory: '384', price: '5.784' },
		{ type: 'z1d.metal', cpu: '48', memory: '384', price: '6.672' },
		{ type: 'z1d.12xlarge', cpu: '48', memory: '384', price: '6.672' },
		{ type: 'r5b.12xlarge', cpu: '48', memory: '384', price: '5.784' },
		{ type: 'r5d.12xlarge', cpu: '48', memory: '384', price: '5.664' },
		{ type: 'r5a.12xlarge', cpu: '48', memory: '384', price: '4.92' },
		{ type: 'r5.12xlarge', cpu: '48', memory: '384', price: '5.232' },
		{ type: 'r5dn.12xlarge', cpu: '48', memory: '384', price: '6.216' },
		{ type: 'r5n.16xlarge', cpu: '64', memory: '512', price: '7.712' },
		{ type: 'r5a.16xlarge', cpu: '64', memory: '512', price: '6.56' },
		{ type: 'r5ad.16xlarge', cpu: '64', memory: '512', price: '7.136' },
		{ type: 'r5b.16xlarge', cpu: '64', memory: '512', price: '7.712' },
		{ type: 'x1e.16xlarge', cpu: '64', memory: '1952', price: '16.288' },
		{ type: 'r4.16xlarge', cpu: '64', memory: '488', price: '7.20' },
		{ type: 'x1.16xlarge', cpu: '64', memory: '976', price: '9.613' },
		{ type: 'r5dn.16xlarge', cpu: '64', memory: '512', price: '8.288' },
		{ type: 'r5.16xlarge', cpu: '64', memory: '512', price: '6.976' },
		{ type: 'r5d.16xlarge', cpu: '64', memory: '512', price: '7.552' },
		{ type: 'r5d.metal', cpu: '96', memory: '768', price: '11.328' },
		{ type: 'r5n.metal', cpu: '96', memory: '768', price: '11.568' },
		{ type: 'r5dn.metal', cpu: '96', memory: '768', price: '12.432' },
		{ type: 'r5b.24xlarge', cpu: '96', memory: '768', price: '11.568' },
		{ type: 'r5b.metal', cpu: '96', memory: '768', price: '11.568' },
		{ type: 'r5n.24xlarge', cpu: '96', memory: '768', price: '11.568' },
		{ type: 'r5a.24xlarge', cpu: '96', memory: '768', price: '9.84' },
		{ type: 'r5dn.24xlarge', cpu: '96', memory: '768', price: '12.432' },
		{ type: 'r5.24xlarge', cpu: '96', memory: '768', price: '10.464' },
		{ type: 'r5.metal', cpu: '96', memory: '768', price: '10.464' },
		{ type: 'r5ad.24xlarge', cpu: '96', memory: '768', price: '10.704' },
		{ type: 'r5d.24xlarge', cpu: '96', memory: '768', price: '11.328' },
		{ type: 'x1e.32xlarge', cpu: '128', memory: '3904', price: '32.576' },
		{ type: 'x1.32xlarge', cpu: '128', memory: '1952', price: '19.226' },
		{ type: 'u-6tb1.56xlarge', cpu: '224', memory: '6144', price: '56.70791' },
		{ type: 'u-12tb1.112xlarge', cpu: '448', memory: '12288', price: '129.808' },
		{ type: 'u-6tb1.112xlarge', cpu: '448', memory: '6144', price: '75.208' },
		{ type: 'u-9tb1.112xlarge', cpu: '448', memory: '9216', price: '102.508' },
		{ type: 'g4ad.xlarge', cpu: '4', memory: '16', price: '0.56253' },
		{ type: 'p2.xlarge', cpu: '4', memory: '61', price: '1.084' },
		{ type: 'g4dn.xlarge', cpu: '4', memory: '16', price: '0.71' },
		{ type: 'g3s.xlarge', cpu: '4', memory: '30.5', price: '0.934' },
		{ type: 'g4dn.2xlarge', cpu: '8', memory: '32', price: '1.12' },
		{ type: 'p3.2xlarge', cpu: '8', memory: '61', price: '3.428' },
		{ type: 'g4ad.2xlarge', cpu: '8', memory: '32', price: '0.90917' },
		{ type: 'g4ad.4xlarge', cpu: '16', memory: '64', price: '1.603' },
		{ type: 'g3.4xlarge', cpu: '16', memory: '122', price: '1.876' },
		{ type: 'g4dn.4xlarge', cpu: '16', memory: '64', price: '1.94' },
		{ type: 'g4dn.8xlarge', cpu: '32', memory: '128', price: '3.648' },
		{ type: 'g4ad.8xlarge', cpu: '32', memory: '128', price: '3.206' },
		{ type: 'g3.8xlarge', cpu: '32', memory: '244', price: '3.752' },
		{ type: 'p2.8xlarge', cpu: '32', memory: '488', price: '8.672' },
		{ type: 'p3.8xlarge', cpu: '32', memory: '244', price: '13.712' },
		{ type: 'g4dn.12xlarge', cpu: '48', memory: '192', price: '6.12' },
		{ type: 'g4dn.16xlarge', cpu: '64', memory: '256', price: '7.296' },
		{ type: 'p2.16xlarge', cpu: '64', memory: '732', price: '17.344' },
		{ type: 'g4ad.16xlarge', cpu: '64', memory: '256', price: '6.412' },
		{ type: 'p3.16xlarge', cpu: '64', memory: '488', price: '27.424' },
		{ type: 'g3.16xlarge', cpu: '64', memory: '488', price: '7.504' },
		{ type: 'p3dn.24xlarge', cpu: '96', memory: '768', price: '35.628' },
		{ type: 'g4dn.metal', cpu: '96', memory: '384', price: '12.24' },
		{ type: 'i3.large', cpu: '2', memory: '15.25', price: '0.248' },
		{ type: 'i3en.large', cpu: '2', memory: '16', price: '0.318' },
		{ type: 'i3.xlarge', cpu: '4', memory: '30.5', price: '0.496' },
		{ type: 'i3en.xlarge', cpu: '4', memory: '32', price: '0.636' },
		{ type: 'd3.xlarge', cpu: '4', memory: '32', price: '0.683' },
		{ type: 'd3en.xlarge', cpu: '4', memory: '16', price: '0.71' },
		{ type: 'd2.xlarge', cpu: '4', memory: '30.5', price: '0.821' },
		{ type: 'd3en.2xlarge', cpu: '8', memory: '32', price: '1.419' },
		{ type: 'd3.2xlarge', cpu: '8', memory: '64', price: '1.367' },
		{ type: 'd2.2xlarge', cpu: '8', memory: '61', price: '1.601' },
		{ type: 'h1.2xlarge', cpu: '8', memory: '32', price: '0.836' },
		{ type: 'i3.2xlarge', cpu: '8', memory: '61', price: '0.992' },
		{ type: 'i3en.2xlarge', cpu: '8', memory: '64', price: '1.272' },
		{ type: 'i3en.3xlarge', cpu: '12', memory: '96', price: '1.908' },
		{ type: 'd3.4xlarge', cpu: '16', memory: '128', price: '2.734' },
		{ type: 'h1.4xlarge', cpu: '16', memory: '64', price: '1.672' },
		{ type: 'd2.4xlarge', cpu: '16', memory: '122', price: '3.062' },
		{ type: 'i3.4xlarge', cpu: '16', memory: '122', price: '1.984' },
		{ type: 'd3en.4xlarge', cpu: '16', memory: '64', price: '2.839' },
		{ type: 'd3en.6xlarge', cpu: '24', memory: '96', price: '4.258' },
		{ type: 'i3en.6xlarge', cpu: '24', memory: '192', price: '3.816' },
		{ type: 'h1.8xlarge', cpu: '32', memory: '128', price: '3.344' },
		{ type: 'd3en.8xlarge', cpu: '32', memory: '128', price: '5.67776' },
		{ type: 'd3.8xlarge', cpu: '32', memory: '256', price: '5.46752' },
		{ type: 'i3.8xlarge', cpu: '32', memory: '244', price: '3.968' },
		{ type: 'd2.8xlarge', cpu: '36', memory: '244', price: '6.198' },
		{ type: 'd3en.12xlarge', cpu: '48', memory: '192', price: '8.51664' },
		{ type: 'i3en.12xlarge', cpu: '48', memory: '384', price: '7.632' },
		{ type: 'i3.metal', cpu: '64', memory: '512', price: '7.936' },
		{ type: 'i3.16xlarge', cpu: '64', memory: '488', price: '7.936' },
		{ type: 'h1.16xlarge', cpu: '64', memory: '256', price: '6.688' },
		{ type: 'i3en.metal', cpu: '96', memory: '768', price: '15.264' },
		{ type: 'i3en.24xlarge', cpu: '96', memory: '768', price: '15.264' },
	],
	gcp: [
		{ type: 'e2-standard-2', cpu: 2, memory: 8, price: '0.067006' },
		{ type: 'e2-standard-4', cpu: 4, memory: 16, price: '0.134012' },
		{ type: 'e2-standard-8', cpu: 8, memory: 32, price: '0.268024' },
		{ type: 'e2-standard-16', cpu: 16, memory: 64, price: '0.536048' },
		{ type: 'e2-standard-32', cpu: 32, memory: 128, price: '1.072096' },
		{ type: 'e2-highmem-2', cpu: 2, memory: 16, price: '0.09039' },
		{ type: 'e2-highmem-4', cpu: 4, memory: 32, price: '0.18078' },
		{ type: 'e2-highmem-8', cpu: 8, memory: 64, price: '0.36156' },
		{ type: 'e2-highmem-16', cpu: 16, memory: 128, price: '0.72312' },
		{ type: 'e2-highcpu-2', cpu: 2, memory: 2, price: '0.049468' },
		{ type: 'e2-highcpu-4', cpu: 4, memory: 4, price: '0.098936' },
		{ type: 'e2-highcpu-8', cpu: 8, memory: 8, price: '0.197872' },
		{ type: 'e2-highcpu-16', cpu: 16, memory: 16, price: '0.395744' },
		{ type: 'e2-highcpu-32', cpu: 32, memory: 32, price: '0.791488' },
		{ type: 'n2-standard-2', cpu: 2, memory: 8, price: '0.097118' },
		{ type: 'n2-standard-4', cpu: 4, memory: 16, price: '0.194236' },
		{ type: 'n2-standard-8', cpu: 8, memory: 32, price: '0.388472' },
		{ type: 'n2-standard-16', cpu: 16, memory: 64, price: '0.776944' },
		{ type: 'n2-standard-32', cpu: 32, memory: 128, price: '1.553888' },
		{ type: 'n2-standard-48', cpu: 48, memory: 192, price: '2.330832' },
		{ type: 'n2-standard-64', cpu: 64, memory: 256, price: '3.107776' },
		{ type: 'n2-standard-80', cpu: 80, memory: 320, price: '3.88472' },
		{ type: 'n2-highmem-2', cpu: 2, memory: 16, price: '0.131014' },
		{ type: 'n2-highmem-4', cpu: 4, memory: 32, price: '0.262028' },
		{ type: 'n2-highmem-8', cpu: 8, memory: 64, price: '0.524056' },
		{ type: 'n2-highmem-16', cpu: 16, memory: 128, price: '1.048112' },
		{ type: 'n2-highmem-32', cpu: 32, memory: 256, price: '2.096224' },
		{ type: 'n2-highmem-48', cpu: 48, memory: 384, price: '3.144336' },
		{ type: 'n2-highmem-64', cpu: 64, memory: 512, price: '4.192448' },
		{ type: 'n2-highmem-80', cpu: 80, memory: 640, price: '5.24056' },
	],
};